import React from "react";
import { db } from "../firebase.config";
import { deleteDoc, doc } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { deleteExhibit } from "../Redux/Exhibits/exhibitSlice";

function Modal({ setModalToggle, deleteExhbitID }) {
  const dispatch = useDispatch();

  const deleteExhibitFirestore = async (exhibitId) => {
    try {
      const docRef = doc(db, "exhibits", exhibitId);
      await deleteDoc(docRef);
      setModalToggle(false);
    } catch (e) {
      console.error("Error deleting document", e);
    }
  };

  const handleConfirm = () => {
    dispatch(deleteExhibit(deleteExhbitID));
    deleteExhibitFirestore(deleteExhbitID);
  };

  return (
    <div
      className="modal-container"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-exhibit-title"
    >
      <div className="my-modal">
        <h2 id="delete-exhibit-title" className="modal-title">
          Delete this exhibit
        </h2>
        <p className="modal-text">
          This will permanently remove the exhibit and its files from your
          dashboard.
        </p>
        <p className="modal-subtext">This action cannot be undone.</p>

        <div className="modal-btn-cont">
          <button
            type="button"
            className="modal-cancel"
            onClick={() => setModalToggle(false)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="modal-delete"
            onClick={handleConfirm}
          >
            Delete exhibit
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
